import styled from "@emotion/styled";
import theme from "../../styles/theme";
import CTA from "../../components/cta/cta";

export const Hero = styled.div`
  box-sizing: border-box;
  padding: ${theme.spacing[8]} ${theme.spacing[4]};
  background: ${theme.gradient.lightBlue};
  margin-bottom: ${theme.spacing[8]};

  ${theme.largerThan["2xl"]} {
    margin-bottom: ${theme.spacing[16]};
    padding: ${theme.spacing[18]} ${theme.spacing[24]};
  }
`;

export const HeroContainer = styled.div`
  max-width: ${theme.narrowWidth};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[8]};
  align-items: center;
  margin: 0 auto;

  ${theme.largerThan.xl} {
    border-radius: 0.5rem;
  }
`;

export const HeroHeader = styled.header`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[4]};
  align-items: center;
`;

export const HeroTitle = styled.h1`
  margin: 0;
  text-align: center;
  max-width: ${theme.narrowWidth};
  color: ${theme.colors.darkBlues[100]};
`;

export const HeroSubTitle = styled.p`
  margin: 0;
  text-align: center;
  color: ${theme.colors.darkBlues[75]};
  max-width: 800px; // TODO: Add this to theme
  font-size: ${theme.fontSizes[1]};
  line-height: ${theme.leading.relaxed};

  ${theme.largerThan.md} {
    font-size: ${theme.fontSizes[3]};
  }
`;

export const HeroCTAWrapper = styled.div`
  text-align: center;
`;

export const HeroCTA = styled(CTA)`
  font-size: ${theme.fontSizes[2]} !important;
  ${theme.largerThan.md} {
    font-size: ${theme.fontSizes[3]} !important;
  }
`;

export const CTACaption = styled.div`
  color: ${theme.colors.darkBlues[75]};
  font-size: ${theme.fontSizes[1]} !important;
  font-weight: ${theme.fontWeights.semibold};
`;

export const ImageWrapper = styled.div`
  max-width: 1000px;
  max-height: 445px;
  border-radius: ${theme.borderRadius};
  overflow: hidden;
`;
